export function pascalToWords(str: string) {
    const spaced = str
        .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
        .replace(/([a-z0-9])([A-Z])/g, "$1 $2");
    return spaced.charAt(0).toUpperCase() + spaced.slice(1);
}

export function camelToWords(str: string) {
    const res = str;
    const resp = res.replace(/([A-Z])/g, " $1");
    return (
        resp.charAt(0).toUpperCase() +
        res.slice(1).replace(/\b([A-Z])\s([A-Z])\b/gi, "$1$2")
    );
}
